import Event from "../event"
import {toMomentDate} from "../../../gd/convert/moment-date"

export default function eventUpdateStartEndDate(event:Event, startDate:Moment|null, endDate:Moment|null) {
    if (!startDate) {
        event.startDate = null
        event.endDate   = null
        return
    }

    // if endDate BEFORE start set start = end because we update START here
    if (!endDate || endDate.isBefore(startDate,'days')) {
        endDate = toMomentDate(startDate)
    }

    event.startDate = toMomentDate(startDate)
    event.endDate   = toMomentDate(endDate)
}